<button mat-raised-button
        color="primary"
        (click)="clickMyButton.emit()">{{title}}</button>
